import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {queryClient} from '@common/http/query-client';
import {useAuth} from '@common/auth/use-auth';

export function useBillingUser() {
	const {user: authUser, isLoggedIn} = useAuth();

	const query = useQuery<{ current_plan: any; projects: any }>({
		queryKey: ['autumn-usage', authUser?.id],
		enabled: isLoggedIn && !!authUser?.id,
		retry: false,
		queryFn: () =>
			apiClient
				.get(`account/usage`)
				.then(r => r.data),
	});

	// Create subscription object from Autumn data
	let subscription = null;
	if (query.data?.current_plan) {
		const plan = query.data.current_plan;
		subscription = {
			id: 1, 
			product: {
				id: plan.id,
				name: plan.name,
				scheduled_changes: plan.scheduled_changes || [],
			},
			price: plan.price ? {
				id: 1,
				amount: plan.price.amount,
				currency: plan.price.currency,
				interval: plan.price.interval,
				interval_count: plan.price.interval_count,
			} : undefined,
			gateway_name: 'autumn',
			gateway_id: 'autumn',
			renews_at: plan.renews_at,
			ends_at: plan.ends_at || null,
			valid: true,
			active: plan.status === 'active',
			cancelled: plan.status === 'cancelled',
			on_trial: plan.is_trial || false,
			scheduled_changes: plan.scheduled_changes || [],
		};
	}

	return {
		subscription,
		isLoading: isLoggedIn ? query.isLoading : false,
		user: isLoggedIn ? authUser : null, // Use auth user directly
	};
}

export function invalidateBillingUserQuery() {
	queryClient.invalidateQueries({queryKey: ['users']});
}
